import React, { Suspense, useEffect } from 'react';
import { useRoutes } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import * as locales from '@mui/material/locale';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Themeroutes from './routes/Router';
import phadaMuiTheme from './ui/muiTheme';
import ThemeSelector from './layouts/theme/ThemeSelector';
import Loader from './layouts/loader/Loader';
import { PermissionsProvider } from './contexts/PermissionsContext';
import { ConfigsProvider } from './contexts/ConfigsContext';
import { PaymentProvider } from './contexts/PaymentContext';
import { PaymentBlockedScreen, PaymentModal } from './components/payment';
import { ChatbotProvider, ChatbotWidget } from './components/chatbot';
import { instalarSessaoGuard } from './utils/sessaoGuard';


const App = () => {
  const routing = useRoutes(Themeroutes);
  const direction = useSelector((state) => state.customizer.isRTL);
  const isMode = useSelector((state) => state.customizer.isDark);

  // Mantem sessionCodidcliente sempre alinhado ao idcliente do token, para o
  // app nunca enviar idcliente divergente (ex.: duas abas em contas diferentes,
  // que compartilham localStorage). Pre-requisito para ligar o
  // TENANT_GUARD_ENFORCE no backend sem quebrar o front.
  useEffect(() => instalarSessaoGuard(), []);

  const [locale] = React.useState('pt_BR');

  // Theme MUI derivado dos tokens Phada (roxo #7B176E) em vez do theme padrão
  // do MUI (azul). Remove a necessidade de overrides `!important` de marca.
  const themeWithLocale = React.useMemo(
    () => createTheme(phadaMuiTheme, locales[locale]),
    [locale],
  );



  return (
    <PermissionsProvider>
      <ConfigsProvider>
        <PaymentProvider>
          <ThemeProvider theme={themeWithLocale}>
            <Suspense fallback={<Loader />}>
              <div
                className={`${direction ? 'rtl' : 'ltr'} ${isMode ? 'dark' : ''}`}
                dir={direction ? 'rtl' : 'ltr'}
              >
                <ChatbotProvider>
                  <ThemeSelector />
                  {routing}
                  <PaymentBlockedScreen />
                  <PaymentModal />
                  <ChatbotWidget />
                  <ToastContainer
                    position="top-right"
                    autoClose={5000}
                    hideProgressBar={false}
                    newestOnTop
                    closeOnClick
                    pauseOnHover
                    limit={3}
                  />
                </ChatbotProvider>
              </div>
            </Suspense>
          </ThemeProvider>
        </PaymentProvider>
      </ConfigsProvider>
    </PermissionsProvider>
  );
};

export default App;
